import React from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';

import { AppBar, Button, IconButton, Toolbar, Theme, Typography, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu'
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import { useTheme } from '@mui/material/styles';

import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";

import { selectProfile } from '../../../reducers/auth';
import graphSettings from '../../../config/graphSettings';

import { Routes } from '../../../constants/routes';
import { selectIsLoading } from '../../../reducers/loading';
import AppProgress from './AppProgress';
import DarkModeButton from './DarkModeButton';

const useStyles = (theme: Theme) => ({
    menuButton: {
        marginRight: theme.spacing(2),
    },
});

export default (props: { name: string }) => {
    const theme = useTheme();
    const classes = useStyles(useTheme());

    const profile = useSelector(selectProfile);
    const isLoading = useSelector(selectIsLoading);
    const { instance } = useMsal();

    const logoutButton = <IconButton disabled={isLoading} color='inherit' onClick={() => instance.logoutRedirect({ postLogoutRedirectUri: '/'})}>
                            <LogoutIcon />
                        </IconButton>;

    const loginButton = <IconButton disabled={isLoading} color='inherit' onClick={() => instance.loginRedirect({ scopes: graphSettings.scopes })}>
                            <LoginIcon />
                        </IconButton>;

    return (
        <div className='container'>
            <AppBar position='fixed'>
                <Toolbar variant='dense'>
	                {/* <IconButton disabled={isLoading} edge='start' sx={classes.menuButton} color='inherit' aria-label='menu'>
                        <MenuIcon />
                    </IconButton> */}
                    <Button className='capitalize' color='inherit' component={RouterLink} disableFocusRipple disableElevation to={Routes.Home}>
                        <Typography variant='h6' color='inherit'>
                            {props.name}
                        </Typography>
                    </Button>       
                    <div className='container'></div>
                    <AuthenticatedTemplate>
                        <Tooltip title='Support'>
                            <IconButton sx={{ mr: 2 }} disabled={isLoading} color='inherit' component={RouterLink} to={Routes.Support}>
                                <HelpCenterIcon color='inherit'/>
                            </IconButton>
                        </Tooltip>
                        <Typography>
                            {profile && profile.mail}
                        </Typography>
                        {isLoading ? logoutButton : <Tooltip title='Abmelden'>{logoutButton}</Tooltip>} 
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                        {isLoading ? loginButton : <Tooltip title='Anmelden'>{loginButton}</Tooltip>} 
                    </UnauthenticatedTemplate>
                    {/* <DarkModeButton theme={theme} /> */}
                </Toolbar>    
				{isLoading && <AppProgress />}
            </AppBar>	
        </div>
    ); 
}